
import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="inline-block bg-purple-100 px-4 py-2 rounded-full mb-8">
              <span className="text-purple-700 font-medium text-sm uppercase tracking-wide">
                WHO WE ARE
              </span>
            </div>
          </div>
          
          <div className="space-y-12">
            <div className="space-y-6">
              <p className="text-2xl text-gray-800 leading-relaxed">
                DEN d.o.o. is a Croatian technology company dedicated to protecting digital privacy and security. 
                We specialize in developing cutting-edge VPN applications that provide users with complete online anonymity 
                and protection against cyber threats.
              </p>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                Located in Pula, Croatia, our team combines local expertise with global standards to deliver 
                world-class security solutions. We believe that privacy is a fundamental right, and our mission 
                is to make advanced security technology accessible to everyone.
              </p>
            </div>
            
            <div className="grid grid-cols-2 gap-12">
              <div className="space-y-4">
                <div>
                  <div className="text-5xl font-bold text-gray-900 mb-2">50+</div>
                  <div className="text-gray-600 font-medium">Countries Covered</div>
                </div>
                
                <div>
                  <div className="flex items-baseline space-x-1">
                    <span className="text-5xl font-bold text-gray-900">256</span>
                    <span className="text-2xl font-medium text-gray-700">-bit</span>
                  </div>
                  <div className="text-gray-600 font-medium">AES Encryption Standard</div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <div className="text-5xl font-bold text-gray-900 mb-2">99.9%</div>
                  <div className="text-gray-600 font-medium">Uptime Guarantee</div>
                </div>
                
                <div>
                  <div className="text-5xl font-bold text-gray-900 mb-2">24/7</div>
                  <div className="text-gray-600 font-medium">Support Available</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
